import React, { FC } from "react";

export interface BgGlassmorphismProps {
  className?: string;
}

const BgGlassmorphism: FC<BgGlassmorphismProps> = ({
  className = "",
}) => {
  return (
    <div
      className={`nc-BgGlassmorphism absolute inset-x-0 top-0 min-h-0 flex overflow-hidden z-0 pointer-events-none ${className}`}
      data-nc-id="BgGlassmorphism"
      aria-hidden="true"
    >
      {/* Orange/Red blob - top right area */}
      <span 
        className="absolute top-20 right-0 lg:right-20 w-72 h-72 lg:w-[500px] lg:h-[500px] rounded-full mix-blend-multiply filter blur-3xl opacity-10 bg-gradient-to-br from-orange-400 to-red-500 animate-blob"
      ></span>
      
      {/* Teal/Blue blob - left side, lower */}
      <span 
        className="absolute top-60 -left-20 lg:left-10 w-72 h-72 lg:w-[450px] lg:h-[450px] rounded-full mix-blend-multiply filter blur-3xl opacity-10 bg-gradient-to-br from-teal-400 to-cyan-500 animate-blob animation-delay-2000"
      ></span>
      
      {/* Optional third blob for more depth - pink accent */}
      <span 
        className="absolute top-40 left-1/3 w-64 h-64 lg:w-80 lg:h-80 rounded-full mix-blend-multiply filter blur-3xl opacity-5 bg-gradient-to-br from-pink-400 to-orange-300 animate-blob animation-delay-4000"
      ></span>
    </div>
  );
};

export default BgGlassmorphism;